import { LoaderCirleModule } from 'src/app/ui-components/loader-cirle/loader-cirle.module';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LazyLoadImageModule } from "ng-lazyload-image";
import { ButtonModule } from "../buttons/button.module";
import { CopyCodeModule } from "../copy-code/copy-code.module";
import { VoucherCardSecondaryComponent } from "./voucher-card-secondary.component";

@NgModule({
    declarations: [VoucherCardSecondaryComponent],
    imports: [CommonModule, ButtonModule, CopyCodeModule,
      LoaderCirleModule,
    LazyLoadImageModule],
    exports: [VoucherCardSecondaryComponent]
})
export class VoucherCardSecondaryModule {

}
